import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ahoy from '@lib/ahoy';
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/compat/router";
import React from 'react';
import IconSvg from "../IconSvg";

const InputButton = forwardRef(function InputButton({
  title = "",
  disabled,
  className,
  onClick = () => {},
  variant = "white", // white or light-gray
  checked = false,
  minWidth,
  leftIconName,
  rightIconName,
  trackingName = "",
  size,
  withTracking = true,
}, ref) {
  const router = useRouter();

  function sendTrackerData() {
    if (!withTracking) return;

    ahoy("$click", {
      tracking_name: trackingName,
      input_button: title || leftIconName,
      page: router.asPath,
    });

    analytics.track("$click", {
      tracking_name: trackingName,
      input_button: title || leftIconName,
      page: router.asPath,
    });
  }

  function handleClick(event) {
    sendTrackerData();
    onClick(event);
  }

  return (
    <button
      ref={ref}
      className={classNames(
        "input-btn font-weight-medium btn hug-content",
        size && `btn-${size} hug-content`,
        variant === "white" && "input-btn-white",
        variant === "light-gray" && "input-btn-light-gray",
        checked && "checked",
        disabled && "disabled",
        !title && "square",
        className,
      )}
      style={{ minWidth }}
      disabled={disabled}
      onClick={handleClick}
    >
      <div className={classNames("btn-container", !title && "icon-only")}>
        {leftIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={leftIconName} />
          </div>
        )}

        <span className="btn-children-container">
          {title}
        </span>

        {rightIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={rightIconName} />
          </div>
        )}
      </div>
    </button>
  );
});

InputButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["white", "light-gray"]),
  checked: PropTypes.bool,
  minWidth: PropTypes.string,
  withTracking: PropTypes.bool,
};

export default InputButton;
